const LessonsStructure = [
  {
    id: 1,
    name: 'Introduksi',
    description: 'Semuanya dimulai dari sini',
    icon: 'star',
    child: [
      {
        id: 1,
        name: 'Hello, world!',
        description: 'Mulai perjalananmu dengan menyapa dunia!',
        xp: 3,
      },
      {
        id: 2,
        name: 'Masukan dan Keluaran',
        description: 'Pelajari bagaimana cara meminta masukan (input) dari pengguna',
        xp: 3,
      },
    ]
  },
  {
    id: 2,
    name: 'Variabel & Ekspresi',
    description: 'Perkenalan tipe dasar',
    icon: 'square',
    child: [
      {
        id: 1,
        name: 'Introduksi ke Variabel',
        description: 'Apa itu variabel dan bagaimana cara menggunakannya?',
        xp: 3,
      },
      {
        id: 2,
        name: 'Ekspresi Matematika',
        description: 'Membentuk sebuah ekspresi dari gabungan variabel dan operator matematika',
        xp: 3,
      },
      {
        id: 3,
        name: 'Luas Lingkaran',
        description: 'Menghitung luas dari lingkaran dengan jari-jari tertentu',
        xp: 5,
      },
    ]
  },
  {
    id: 3,
    name: 'Percabangan',
    description: 'Membuat percabangan alur di dalam program',
    icon: 'project-diagram',
    child: [
      {
        id: 1,
        name: 'Jika Ini, Maka Itu',
        description: 'Perkenalan ke blok if',
        xp: 3,
      },
      {
        id: 2,
        name: 'Percabangan Lanjut',
        description: 'Bagaimana membuat percabangan yang memuat lebih dari 1 kasus?',
        xp: 5,
      },
      {
        id: 3,
        name: 'Kasus Bilangan',
        description: 'Menentukan angka yang positif genap, positif ganjil, nol, dan negatif',
        xp: 5,
      }
    ]
  },
  {
    id: 4,
    name: 'Perulangan',
    description: 'Memanfaatkan perulangan untuk menyelesaikan permasalahan',
    icon: 'redo',
    child: [
      {
        id: 1,
        name: 'Hukuman Guru',
        description: 'Perkenalan ke blok repeat',
        xp: 3,
      },
      {
        id: 2,
        name: 'Deret Aritmatika',
        description: 'Perkenalan ke blok while',
        xp: 5,
      },
      {
        id: 3,
        name: 'Deret Aritmatika 2',
        description: 'Perkenalan ke blok for',
        xp: 5,
      },
      {
        id: 4,
        name: 'Dua Pangkat',
        description: 'Periksa apakah sebuah bilangan merupakan "dua pangkat" atau tidak',
        xp: 7,
      }
    ]
  },
  {
    id: 5,
    name: 'List',
    description: 'Perkenalan ke tipe data kompleks',
    icon: 'bars',
    child: [
      {
        id: 1,
        name: 'Cetak Elemen List',
        description: 'Perkenalan ke list dan elemennya',
        xp: 3,
      },
      {
        id: 2,
        name: 'Cetak List',
        description: 'Cetak list ke arah bawah',
        xp: 5,
      },
      {
        id: 3,
        name: 'Cetak List 2',
        description: 'Cetak list ke arah bawah dari elemen terakhir sampai elemen pertama',
        xp: 7,
      }
    ]
  },
  {
    id: 6,
    name: 'Fungsi',
    description: 'Membuat dan memanipulasi <i>fungsi</i>',
    icon: 'superscript',
    child: [
      {
        id: 1,
        name: 'Pangkat Lima',
        description: 'Perkenalan ke fungsi dan kegunaannya',
        xp: 5,
      },
      {
        id: 2,
        name: 'Komposisi Fungsi',
        description: 'Menghitung fungsi di dalam fungsi',
        xp: 7,
      }
    ]
  },
  {
    id: 7,
    name: 'Tingkat Lanjut',
    description: 'Tantang kemampuan berpikirmu dengan paduan materi yang telah kamu pelajari',
    icon: 'arrow-circle-right',
    child: [
      {
        id: 1,
        name: 'Uji Palindrom',
        description: 'Periksa apakah suatu teks merupakan palindrom atau bukan',
        xp: 10,
      },
    ]
  },
]

export default LessonsStructure
